"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_UNIQUEST_LINKS = void 0;
exports.GET_UNIQUEST_LINKS = `
  {
    engagementMenuList
  }
`;
//# sourceMappingURL=uniquest-queries.js.map